export const SYSTEM_DETAILS_LABEL = 'System Details'
export const STATE = 'STATE'
export const DESTINATION = 'DESTINATION'
export const STATE_CODE = 'State Code'
export const DESTINATION_CODE = 'Destination Code'
